import { BasketStore } from "../stores/basket.js";

export const BasketComponent = {
    template: `
        <div class="basket container">
            <h2>Basket</h2>
            <table>
                <thead>
                    <tr>
                        <th>Items</th>
                        <th>Price</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody id="BasketItems"></tbody>
                <tfoot>
                    <tr>
                        <th class="right">Total: </th>
                        <th id="BasketTotal" class="right"></th>
                        <th></th>
                    </tr>
                </tfoot>
            </table>
            <div class="buttons">
                <button id="BasketClear" class="red">Clear</button>
                <a href="/shop/checkout"><button>Checkout</button></a>
            </div>
        </div>
    `,

    async onMount() {
        const $items = document.getElementById("BasketItems");
        const $total = document.getElementById("BasketTotal");

        const render = (basket) => {
            $items.innerHTML = "";

            if (basket.length === 0) {
                $items.innerHTML = `<tr><td colspan="3">Your basket is empty</td></tr>`;
                $total.innerHTML = '&pound;0.00';
                return;
            }

            let total_cost = 0;
            basket.forEach(product => {
                const row = document.createElement("tr");
                const cost = (product.cost || 0) * product.quantity;
                const cost_string = '&pound;' + (cost / 100).toFixed(2);
                row.className = "product";
                row.dataset.productId = product.id;
                row.innerHTML = `<td>${product.name}</td><td class="right">${cost_string}</td><td><button class="remove icon red" title="Remove"><i class="fas fa-times"></i></button></td>`;
                $items.appendChild(row);

                total_cost += cost;
            });

            $total.innerHTML = '&pound;' + (total_cost / 100).toFixed(2);
        };

        this._onClear = () => {
            BasketStore.clear();
        };

        const $button_clear = document.getElementById('BasketClear');
        $button_clear.addEventListener("click", this._onClear);

        $items.addEventListener('click', (e) => {
            const $button = e.target.closest('.remove');
            if (!$button) return;

            const $product = $button.closest('.product');
            if (!$product) return;

            const product_id = parseInt($product.dataset.productId);

            BasketStore.remove(product_id);
        });

        this.unsubscribe = BasketStore.subscribe(render);
    },

    async onUnmount() {
        this.unsubscribe?.();

        const $button_clear = document.getElementById('BasketClear');
        if ($button_clear && this._onClear) {
            $button_clear.removeEventListener("click", this._onClear);
        }
    }
};
